import React, { useEffect } from 'react';
import { RxCross2 } from 'react-icons/rx';

interface WPStatusModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (status: 'publish' | 'draft') => void;
    isLoading: boolean;
    campaignName?: string;
}

const WPStatusModal: React.FC<WPStatusModalProps> = ({
    isOpen,
    onClose,
    onConfirm,
    isLoading,
    campaignName,
}) => {
    useEffect(() => {
        const keyHandler = ({ keyCode }: KeyboardEvent) => {
            if (keyCode === 27 && !isLoading) onClose();
        };
        if (isOpen) {
            document.addEventListener('keydown', keyHandler);
        }
        return () => document.removeEventListener('keydown', keyHandler);
    }, [isOpen, onClose, isLoading]);

    if (!isOpen) return null;

    return (
        <div
            className='fixed left-0 top-0 z-999999 flex h-full min-h-screen w-full items-center justify-center bg-black/90 px-4 py-5'
            onClick={onClose}
        >
            <div
                onClick={(e) => e.stopPropagation()}
                className='relative w-full max-w-xl rounded-lg bg-white shadow-lg'
            >
                <button
                    className='absolute right-4 top-4 text-gray-600 hover:text-gray-900'
                    onClick={onClose}
                    disabled={isLoading}
                >
                    <RxCross2 />
                </button>
                <div className='p-8'>
                    <h2 className='mb-[30px] text-[22px] font-bold'>
                        Website Campaign Visibility
                    </h2>

                    <p className='mb-[30px]'>
                        {campaignName
                            ? `Choose whether to make "${campaignName}" public or private on the website.`
                            : 'Choose whether to make this campaign public or private on the website.'}
                    </p>

                    <div className='flex justify-start space-x-4'>
                        <button
                            onClick={onClose}
                            disabled={isLoading}
                            className='rounded-full border-[2px] px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase transition-colors duration-500 hover:border-black hover:bg-black hover:text-white disabled:opacity-50 disabled:cursor-not-allowed'
                        >
                            Cancel
                        </button>
                        <button
                            onClick={() => onConfirm('draft')}
                            disabled={isLoading}
                            className='rounded-full border-[2px] border-danger px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase text-danger transition-colors duration-500 hover:bg-danger hover:text-white disabled:opacity-50 disabled:cursor-not-allowed'
                        >
                            {isLoading ? 'Updating...' : 'Make Private'}
                        </button>
                        <button
                            onClick={() => onConfirm('publish')}
                            disabled={isLoading}
                            className='rounded-full bg-primary px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase text-white transition-colors duration-500 hover:bg-opacity-90 disabled:opacity-50 disabled:cursor-not-allowed'
                        >
                            {isLoading ? 'Updating...' : 'Make Public'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WPStatusModal;
